<template>
  <div>
    <router-view />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {

  data () {
    return {}
  },
  computed: {
    ...mapState('project', ['project']),
    pid () {
      return this.$store.state.pid || this.$route.params.pid
    },
    rolename () {
      return this.$store.state.baseinfo.rolename
    },
    changeRoleTip () {
      return this.$t('message["688"]').split('|')
    }
  },
  watch: {
    pid (pid) {
      this.init()
    },
    rolename (val) {
      if (val) {
        this.showClose()
      }
    }
  },
  created () {
    this.init()
  },
  methods: {
    ...mapActions('project', ['setPid', 'fetchDatas', 'closeRoleTip']),
    async init () {
      await this.setPid(this.pid)

      const chain = await this.fetchDatas()
      chain
        .params({
          id: this.pid
        })
        .onSuccess(raw => {
          if (this.rolename) {
            this.showClose()
          }
        })
        .fetch()
    },
    showClose () {
      this.$createDialog({
        type: 'alert',
        title: this.$t('message["504"]'),
        confirmBtn: {
          text: this.$t('message["1276"]'),
          active: true
        },
        showClose: false,
        content: `${this.changeRoleTip[0]}[${this.rolename}]${this.changeRoleTip[1]}`,
        onConfirm: () => {
          this.closeHanler()
        }
      }).show()
    },
    async closeHanler () {
      const chain = await this.closeRoleTip()
      chain.onSuccess(raw => {
        this.TipDialogVisible = false
      })
        .fetch()
    }
  }
}
</script>

<style lang="scss">
@import '../../assets/css/mobile.scss';
</style>
